import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../../service/utils.service';
import { GlobalConfig } from '../../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-set-area',
  templateUrl: './set-area.component.html',
  styleUrls: ['./set-area.component.css']
})
export class SetAreaComponent implements OnInit {
  areaId: any = '';
  apiUrl: any = '';
  areaForm: FormGroup;
  formErrors: any;
  submitted: Boolean = false;
  country: any[] = [];
  state: any[] = [];
  city: any[] = [];
  district: any[] = [];
  isEdit: Boolean = false;
  constructor(
    private route: ActivatedRoute,
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager
  ) {
    this.areaId = route.snapshot.params['id'];
  }

  areas: any = {
    countryId: '',
    stateId: '',
    cityId: '',
    districtId: '',
    area: '',
  };
  ngOnInit() {
    this.apiUrl = this.config.apiRootUrl;
    if (this.areaId > 0) {
      this.isEdit = true;
      this.getAreaDetail(this.areaId);
    }
    this.getDistricts();
    this.getCountry();
    this.getState();
    this.getCity(); 
  }

  getDistricts() {
    this.servicesComponent.getDistricts()
      .then((response: any) => {
        if (response.success) {
          this.district = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });

  }

  getCity() {
    this.servicesComponent.getCity()
      .then((response: any) => {
        if (response.success) {
          this.city = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getState() {
    this.servicesComponent.getState()
      .then((response: any) => {
        if (response.success) {
          this.state = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getCountry() {
    this.servicesComponent.getCountry()
      .then((response: any) => {
        if (response.success) {
          this.country = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }


  addArea(form) {
    this.submitted = false;
    if (form.valid) {
      this.servicesComponent.saveArea(this.areas)
        .then((response: any) => {
          if (response.receiveObj.success == true) {
            this.router.navigate(['./areas']);
            this.toastr.success('area saved successfully.', 'Success!');
          }
          else {
            this.toastr.error('Some error occured, Please contact admin.', 'Error!');
          }

        })
        .catch(error => {
          console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    } else {
      this.submitted = true;
    }
  }

  getAreaDetail(id) {
    this.servicesComponent.getAreaDetail(id)
      .then((response: any) => {
        if (response.success) {
          this.areas = response.receiveObj;

        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  updateArea(form) {
    this.submitted = false;
    if (form.valid) {
      this.servicesComponent.updateArea(this.areas)
        .then((response: any) => {
          if (response.receiveObj.success) {
            this.router.navigate(['./areas']);
            this.toastr.success('area update successfully.', 'Success!');
          } else if (!response.receiveObj.success && response.receiveObj.duplicateUser) {
            this.toastr.info('This user is already exist.', 'Info!');
          }
        })
        .catch(error => {
          console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    } else {
      this.submitted = true;
    }
  }

}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/areasManagement/areas/set-area/set-area.component.ts